/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface GetEntityTypeSubscriptionsRequest {
    entityType: string;
    sessionId: string;
}

export interface GetSubscriptionStatisticsRequest {
    sessionId: string;
}

export interface SubscribeToEntityTypeRequest {
    entityType: string;
    sessionId: string;
}

export interface SubscribeToFieldRequest {
    entityType: string;
    fieldName: string;
    sessionId: string;
}

export interface SubscribeToTenantRequest {
    tenantId: string;
    sessionId: string;
}

/**
 * DataChangeManagementApi - interface
 * 
 * @export
 * @interface DataChangeManagementApiInterface
 */
export interface DataChangeManagementApiInterface {
    /**
     * Get current subscriptions for a specific entity type.
     * @summary Get entity type subscriptions
     * @param {string} entityType Entity type
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataChangeManagementApiInterface
     */
    getEntityTypeSubscriptionsRaw(requestParameters: GetEntityTypeSubscriptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get current subscriptions for a specific entity type.
     * Get entity type subscriptions
     */
    getEntityTypeSubscriptions(requestParameters: GetEntityTypeSubscriptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves statistics about data change subscriptions.
     * @summary Get subscription statistics
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataChangeManagementApiInterface
     */
    getSubscriptionStatisticsRaw(requestParameters: GetSubscriptionStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves statistics about data change subscriptions.
     * Get subscription statistics
     */
    getSubscriptionStatistics(requestParameters: GetSubscriptionStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Subscribe to data changes for a specific entity type.
     * @summary Subscribe to entity type changes
     * @param {string} entityType Entity type to subscribe to
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataChangeManagementApiInterface
     */
    subscribeToEntityTypeRaw(requestParameters: SubscribeToEntityTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Subscribe to data changes for a specific entity type.
     * Subscribe to entity type changes
     */
    subscribeToEntityType(requestParameters: SubscribeToEntityTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Subscribe to data changes for a specific field in an entity type.
     * @summary Subscribe to field changes
     * @param {string} entityType Entity type
     * @param {string} fieldName Field name
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataChangeManagementApiInterface
     */
    subscribeToFieldRaw(requestParameters: SubscribeToFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Subscribe to data changes for a specific field in an entity type.
     * Subscribe to field changes
     */
    subscribeToField(requestParameters: SubscribeToFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Subscribe to data changes for a specific tenant.
     * @summary Subscribe to tenant changes
     * @param {string} tenantId Tenant ID
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataChangeManagementApiInterface
     */
    subscribeToTenantRaw(requestParameters: SubscribeToTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Subscribe to data changes for a specific tenant.
     * Subscribe to tenant changes
     */
    subscribeToTenant(requestParameters: SubscribeToTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class DataChangeManagementApi extends runtime.BaseAPI implements DataChangeManagementApiInterface {

    /**
     * Get current subscriptions for a specific entity type.
     * Get entity type subscriptions
     */
    async getEntityTypeSubscriptionsRaw(requestParameters: GetEntityTypeSubscriptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['entityType'] == null) {
            throw new runtime.RequiredError(
                'entityType',
                'Required parameter "entityType" was null or undefined when calling getEntityTypeSubscriptions().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getEntityTypeSubscriptions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/data-change/subscriptions/entity-type/{entityType}`;
        urlPath = urlPath.replace(`{${"entityType"}}`, encodeURIComponent(String(requestParameters['entityType'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get current subscriptions for a specific entity type.
     * Get entity type subscriptions
     */
    async getEntityTypeSubscriptions(requestParameters: GetEntityTypeSubscriptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getEntityTypeSubscriptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves statistics about data change subscriptions.
     * Get subscription statistics
     */
    async getSubscriptionStatisticsRaw(requestParameters: GetSubscriptionStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getSubscriptionStatistics().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/data-change/subscriptions/statistics`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves statistics about data change subscriptions.
     * Get subscription statistics
     */
    async getSubscriptionStatistics(requestParameters: GetSubscriptionStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getSubscriptionStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Subscribe to data changes for a specific entity type.
     * Subscribe to entity type changes
     */
    async subscribeToEntityTypeRaw(requestParameters: SubscribeToEntityTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['entityType'] == null) {
            throw new runtime.RequiredError(
                'entityType',
                'Required parameter "entityType" was null or undefined when calling subscribeToEntityType().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling subscribeToEntityType().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/data-change/subscribe/entity-type/{entityType}`;
        urlPath = urlPath.replace(`{${"entityType"}}`, encodeURIComponent(String(requestParameters['entityType'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Subscribe to data changes for a specific entity type.
     * Subscribe to entity type changes
     */
    async subscribeToEntityType(requestParameters: SubscribeToEntityTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.subscribeToEntityTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Subscribe to data changes for a specific field in an entity type.
     * Subscribe to field changes
     */
    async subscribeToFieldRaw(requestParameters: SubscribeToFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['entityType'] == null) {
            throw new runtime.RequiredError(
                'entityType',
                'Required parameter "entityType" was null or undefined when calling subscribeToField().'
            );
        }

        if (requestParameters['fieldName'] == null) {
            throw new runtime.RequiredError(
                'fieldName',
                'Required parameter "fieldName" was null or undefined when calling subscribeToField().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling subscribeToField().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/data-change/subscribe/field/{entityType}/{fieldName}`;
        urlPath = urlPath.replace(`{${"entityType"}}`, encodeURIComponent(String(requestParameters['entityType'])));
        urlPath = urlPath.replace(`{${"fieldName"}}`, encodeURIComponent(String(requestParameters['fieldName'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Subscribe to data changes for a specific field in an entity type.
     * Subscribe to field changes
     */
    async subscribeToField(requestParameters: SubscribeToFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.subscribeToFieldRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Subscribe to data changes for a specific tenant.
     * Subscribe to tenant changes
     */
    async subscribeToTenantRaw(requestParameters: SubscribeToTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling subscribeToTenant().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling subscribeToTenant().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/data-change/subscribe/tenant/{tenantId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Subscribe to data changes for a specific tenant.
     * Subscribe to tenant changes
     */
    async subscribeToTenant(requestParameters: SubscribeToTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.subscribeToTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
